import React from 'react';

const PanelChangeSspIcon = ({src, className}) => {
  if (!src) return null;

  return <img src={src} alt="" className={className} aria-hidden />;
};

export default React.memo(PanelChangeSspIcon);
